import React from 'react';
import { IIconProps } from './utils';

export const Stop = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 14 14"
    width={width}
    {...rest}
  >
    <rect fill={fill} height="14" rx="2" width="14" />
  </svg>
);
